import React, { useState, useEffect } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Close from "../../../assets/icons/Close.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsOpenModelEditDepartmentMaster,
  updateDepartmentMasterList,
} from "../../../redux/actions/mastersAction";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

const EditDepartmentMasterModel = (Props) => {
  const dispatch = useDispatch();

  const EditDepartmentMasterModel = useSelector(
    (state) => state?.masters?.EditDepartmentMasterModel
  );

  const [DepartmentName, SetDepartmentName] = React.useState("");

  const handleChangeDepartmentName = (event) => {
    SetDepartmentName(event.target.value);
  };

  useEffect(() => {
    SetDepartmentName(EditDepartmentMasterModel?.EditRowDataModel?.name);
  }, [EditDepartmentMasterModel]);

  const handleSaveDepartment = async (event) => {
    event.preventDefault();
    if (DepartmentName !== "") {
      dispatch(
        updateDepartmentMasterList({
          name: DepartmentName,
          id: EditDepartmentMasterModel?.EditRowDataModel?.id,
        })
      );
    } else {
      toast.error("Please enter Department Name");
    }
  };

  return (
    <Modal
      open={EditDepartmentMasterModel?.isOpenEditModel}
      onClose={() => {
        const payload = {
          isOpenEditModel: false,
          EditRowDataModel: [],
        };
        dispatch(setIsOpenModelEditDepartmentMaster(payload));
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Edit Department
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={() => {
                const payload = {
                  isOpenEditModel: false,
                  EditRowDataModel: [],
                };
                dispatch(setIsOpenModelEditDepartmentMaster(payload));
              }}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Department Name"
                type="text"
                value={DepartmentName}
                onChange={handleChangeDepartmentName}
                sx={{
                  width: "100%",
                  borderRadius: "50px",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none", 
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Box>
              <Button
                // variant="contained"
                sx={{
                  fontSize: "15px",
                  border: "1px solid #26875C",
                  fontWeight: 600,
                  width: "8rem",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                }}
                onClick={() => {
                  const payload = {
                    isOpenEditModel: false,
                    EditRowDataModel: [],
                  };
                  dispatch(setIsOpenModelEditDepartmentMaster(payload));
                }}
              >
                Cancel
              </Button>
            </Box>
            <Box>
              <Button
                onClick={handleSaveDepartment}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "8rem",
                  border: "1px solid #26875C",
                  backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditDepartmentMasterModel;
